module.exports = __webpack_public_path__ + "static/media/10CreacionCotizacion-10.22db9e91.png";